
import ProductIcon from '../../common/assets/svgIcons/ProductIcon';
import ServicesIcon from '../../common/assets/svgIcons/ServicesIcon';
import ProductServiceCard from './ProductServiceCard';
import { selectProductAndServices } from '../../../Selector/CompaniesSelector';
import { useSelector } from 'react-redux';
import { selectClusterProductAndServices } from '../../../Selector/ClustersSelector';

type Props = {
  isCluster?: boolean;
  clusterCompanyId?: number;
}

const defaultProps = {
  isCluster: false,
  clusterCompanyId: 0,
}

const ProductAndServices = function ProductAndServices(props: Props) {
  const { isCluster, clusterCompanyId } = props;
  const clusterProductsAndServices = useSelector(selectClusterProductAndServices);
  const productsAndServices = isCluster ? clusterProductsAndServices[clusterCompanyId ?? 0] : useSelector(selectProductAndServices);

  return (
    <div>
      {!!productsAndServices?.products?.length &&
        <ProductServiceCard title="Products" icon={<ProductIcon />} items={productsAndServices?.products || []} />
      }
      {!!productsAndServices?.services?.length &&
        <ProductServiceCard title="Services" icon={<ServicesIcon />} items={productsAndServices?.services || []} />
      }
    </div>
  );
};
ProductAndServices.defaultProps = defaultProps;
export default ProductAndServices;
